import { daUtils } from '../_utils';
import {
    IApiResponse,
    IDatasourceRequest,
    IItemIdRequest, IItemIdsRequest,
    IItemSIdRequest,
    IBroker,
    IMuiDataRequest,
} from "./types";
import { API_PAF_BASE_URI } from "./index";

const API_LIST_ADMIN_GET = `${API_PAF_BASE_URI}/listadmins/filter/`;
const API_LIST_ADMIN_GET_BY_ID = `${API_PAF_BASE_URI}/listadmins/{listadmin_id}/`;
const API_LIST_ADMIN_GET_BY_SID = `${API_PAF_BASE_URI}/listadmins/sid/{listadmin_sid}/`;
const API_LIST_ADMIN_ADD = `${API_PAF_BASE_URI}/listadmins/`;
const API_LIST_ADMIN_UPD = `${API_PAF_BASE_URI}/listadmins/{listadmin_id}/`;
const API_LIST_ADMIN_DEL = `${API_PAF_BASE_URI}/listadmins/delete/`;
const API_BROKER_LIST = `${API_PAF_BASE_URI}/listadmins/paf_owner/`;
const API_BROKER_DETAILS_BY_ID = `${API_PAF_BASE_URI}/listadmins/paf_view/{listadmin_id}/`;

const get = async (
    options: IMuiDataRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_LIST_ADMIN_GET;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        return resp;
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_by_id = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: "GET",
            cache: "no-cache",
        };
        const id = options.id.toString();
        const url = API_LIST_ADMIN_GET_BY_ID.replace('{listadmin_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_by_sid = async (
    options: IItemSIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const sid = options.sid;
        const url = API_LIST_ADMIN_GET_BY_SID.replace('{listadmin_sid}', sid);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}


const add = async (
    options: IBroker,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_LIST_ADMIN_ADD;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const update = async (
    options: IBroker,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'PUT',
            body: JSON.stringify(options)
        };
        const id = options.listadmin_id!.toString();
        const url = API_LIST_ADMIN_UPD.replace('{listadmin_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const remove = async (
    options: IItemIdsRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'DELETE',
            body: JSON.stringify(options)
        };
        const url = API_LIST_ADMIN_DEL;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_broker_list = async (
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const url = API_BROKER_LIST;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_broker_details_by_id = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const id = options.id.toString();
        const url = API_BROKER_DETAILS_BY_ID.replace('{listadmin_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

export const brokerApi = {
    get,
    get_by_id,
    get_by_sid,
    add,
    update,
    remove,
    get_broker_list,
    get_broker_details_by_id,
};